import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';

export const getIsSelectedCountryDifferent = nationality => {
    return getReferenceCodeByCountry().toLowerCase() !== nationality.toLowerCase();
};
